import { medusaRequester, requester, storeRequester } from "App";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate, useOutletContext } from "react-router-dom";
import WishCardListRow from "./WishCardListRow";
import NiceModal from "@ebay/nice-modal-react";
import CustomPagination from "components/pagination/CustomPagination";

function WishCardList(props) {
  const { isMobile } = useContext(BrowserDetectContext);
  const [myWishProducts, setMyWishProducts] = useState();
  const [wishDelete, setWishDelete] = useState(false);

  const { products } = useSelector((state) => ({
    products: state.wish.products,
  }));

  const getWishList = async () => {
    const { customer } = await storeRequester.getCurrentCustomer();
    if (customer.id) {
      medusaRequester
        .getMyWishProducts(customer.id, (result) =>
          setMyWishProducts(result.interests)
        )
        .catch((e) => {
          
        });
    }
  };

  useEffect(() => {
    // window.scrollTo(0, 0);
    getWishList();
  }, [wishDelete]);

  // ====== paging ======
  const itemsPerPage = 5; // 한 페이지에 보여줄 아이템 개수
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  useEffect(() => {
    if (myWishProducts && myWishProducts.length > 0) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setCurrentData(myWishProducts.slice(startIndex, endIndex));
    }
  }, [currentPage, myWishProducts]);
  // ====== paging ======

  return (
    <VerticalFlex>
      {currentData &&
        currentData.length > 0 &&
        currentData.map((data, index) => {
          return (
            <WishCardListRow
              data={data.product}
              index={index}
              key={index}
              setWishDelete={setWishDelete}
            />
          );
        })}
      <CustomPagination
        currentPage={currentPage}
        totalPages={
          myWishProducts &&
          myWishProducts.length > 0 &&
          Math.ceil(myWishProducts.length / itemsPerPage)
        }
        onPageChange={(page) => setCurrentPage(page)}
      />
    </VerticalFlex>
  );
}

export default WishCardList;
